import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { heroSlides } from "@/mocks/videos";
import type { HeroSlide } from "@/types/video";

export default function HeroCarousel() {
  const slides = heroSlides as HeroSlide[];
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((i) => (i + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const go = (next: number) => {
    setIndex((next + slides.length) % slides.length);
  };

  return (
    <section className="relative w-full">
      <div className="relative w-full h-[360px] sm:h-[440px] lg:h-[540px] overflow-hidden bg-foreground-950">
        {slides.map((slide, i) => (
          <Link
            key={slide.id}
            to={`/detail/${slide.videoId}`}
            className={`absolute inset-0 transition-opacity duration-700 cursor-pointer ${
              i === index ? "opacity-100 z-10" : "opacity-0 pointer-events-none z-0"
            }`}
          >
            <img
              src={slide.image}
              alt={slide.title}
              title={`${slide.title} - 西瓜视频`}
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/45 to-foreground-950/20"></div>
            <div className="absolute inset-0 flex items-end">
              <div className="w-full px-5 md:px-12 pb-12 md:pb-16">
                <span className="inline-block px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium mb-3">
                  精选推荐
                </span>
                <h2 className="text-background-50 text-2xl md:text-5xl font-bold font-heading mb-2 md:mb-3">
                  {slide.title}
                </h2>
                <p className="text-background-200 text-sm md:text-lg mb-5 md:mb-6 max-w-2xl">
                  {slide.subtitle}
                </p>
                <span className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap transition-colors">
                  <i className="ri-play-fill text-base w-4 h-4 flex items-center justify-center"></i>
                  立即观看
                </span>
              </div>
            </div>
          </Link>
        ))}

        <button
          type="button"
          onClick={() => go(index - 1)}
          aria-label="上一张"
          className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 z-20 w-9 h-9 md:w-11 md:h-11 rounded-full bg-foreground-950/40 hover:bg-primary-500 text-background-50 flex items-center justify-center transition-colors cursor-pointer"
        >
          <i className="ri-arrow-left-s-line text-2xl"></i>
        </button>
        <button
          type="button"
          onClick={() => go(index + 1)}
          aria-label="下一张"
          className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 z-20 w-9 h-9 md:w-11 md:h-11 rounded-full bg-foreground-950/40 hover:bg-primary-500 text-background-50 flex items-center justify-center transition-colors cursor-pointer"
        >
          <i className="ri-arrow-right-s-line text-2xl"></i>
        </button>

        <div className="absolute bottom-5 left-1/2 -translate-x-1/2 z-20 flex items-center gap-2">
          {slides.map((slide, i) => (
            <button
              key={slide.id}
              type="button"
              onClick={() => go(i)}
              aria-label={`切换到第 ${i + 1} 张`}
              className={`h-1.5 rounded-full transition-all cursor-pointer ${
                i === index ? "w-6 bg-primary-500" : "w-1.5 bg-background-200/70"
              }`}
            ></button>
          ))}
        </div>
      </div>
    </section>
  );
}